export const SET_CURRENCY = "SET_CURRENCY";

export const setCurrency = currencyName => {
  return dispatch => {
    dispatch({
      type: SET_CURRENCY,
      payload: { currencyName }
    })
  };
};
export const setUserCurrency = user => {
  return dispatch => {
    dispatch({
      type: SET_CURRENCY,
      payload: { currencyName: "USER_CURRENCY", user }
    })
  };
};
